var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"product__gallery"},[(_vm.isFetching)?_c('SfLoader',{staticClass:"loading--product-gallery",attrs:{"loading":_vm.isFetching}}):_vm._e(),_vm._v(" "),_c('SfGallery',{attrs:{"images":_vm.productGallery,"image-width":_vm.imageSizes.productGallery.imageWidth,"image-height":_vm.imageSizes.productGallery.imageHeight,"thumb-width":_vm.imageSizes.productGallery.thumbWidth,"thumb-height":_vm.imageSizes.productGallery.thumbHeight,"enable-zoom":false,"image-tag":"nuxt-img","thumb-image-tag":"nuxt-img","nuxt-img-config":{
      fit: 'cover',
      width: null,
      height: null,
    },"thumb-nuxt-img-config":{
      fit: 'cover',
    },"slider-options":{
      type: 'slider',
      autoplay: false,
      rewind: false,
      gap: 0,
      keyboard: true,
      arrows: true,
    },"product3-d-entries":_vm.product3DEntries}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }